const defaultHash = (args) => {
    // JSON.stringify ellides `undefined` and function values by default. We do not want that.
    return JSON.stringify(args, (_, v) => (typeof v === 'object' ? v : String(v)));
};
/**
 * Memoizes a function to cache results based on input arguments.
 */
const memoize = (fn, { cache: customCache, hash = defaultHash } = {}) => {
    const cache = customCache ?? new Map();
    const memoizedFn = (...args) => {
        const key = hash(args);
        if (cache.has(key)) {
            return cache.get(key);
        }
        const result = fn(...args);
        cache.set(key, result);
        return result;
    };
    memoizedFn.cache = cache;
    return memoizedFn;
};
export default memoize;
